export const SET_GROUPS = 'SET_GROUPS'
export const UPDATE_GROUPS = 'UPDATE_GROUPS'
export const ADD_GROUP_USER = 'ADD_GROUP_USER'
export const REMOVE_GROUP_USER = 'REMOVE_GROUP_USER'
export const REMOVE_GROUP = 'REMOVE_GROUP'

export const SET_ACTIVE_GROUPS = 'SET_ACTIVE_GROUPS'
export const UPDATE_ACTIVE_GROUP = 'UPDATE_ACTIVE_GROUP'
export const REMOVE_ACTIVE_GROUP = 'REMOVE_ACTIVE_GROUP'